import { ActionType, createReducer } from 'typesafe-actions';
import { saveTableSettingsToStoreAction, updateDealerAction, updateGameIdAction } from './actions';
import { ITableSettingsState } from './types';

export const tableSettingsState: ITableSettingsState | null = null;

const actions = {
  saveTableSettingsToStoreAction,
  updateGameIdAction,
  updateDealerAction,
};

export const tableSettingsReducer = createReducer<
  ITableSettingsState | null,
  ActionType<typeof actions>
>(tableSettingsState)
  .handleAction(
    saveTableSettingsToStoreAction,
    (
      state,
      {
        payload: {
          tableId,
          tableName,
          gameId,
          dealerNickname,
          minBetLimit,
          maxBetLimit,
          displayingWinResult,
          tableLimits,
        },
      },
    ) => ({
      ...state,
      tableId,
      tableName,
      gameId,
      displayingWinResult,
      dealer: {
        nickname: dealerNickname,
      },
      tableLimits,
    }),
  )
  .handleAction(updateGameIdAction, (state, { payload: { gameId } }) => {
    if (state === null) {
      return null;
    }

    return {
      ...state,
      gameId,
    };
  })
  .handleAction(updateDealerAction, (state, { payload: { dealerNickname } }) => {
    if (state === null) {
      return null;
    }

    return {
      ...state,
      dealer: {
        nickname: dealerNickname,
      },
    };
  });
